import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TicketUtilityService {

  constructor() { }

  transformLicensePlateNumber(licensePlateNumber: string): string {
    if (licensePlateNumber) {
      let newCharacters: string[] = [];

      for (let i = 0; i < licensePlateNumber.length; i++) {
        const character = licensePlateNumber[i].toLocaleUpperCase();
        if (character === 'Å' || character === 'Ä') {
          newCharacters.push('A');
        }
        else if (character === 'Ö') {
          newCharacters.push('O');
        }
        else if (character === 'Ü') {
          newCharacters.push('U');
        }
        else {
          newCharacters.push(character);
        }
      }
  
      return newCharacters.join('').replace(/\s+/g, "");
    }
    else {
      return '';
    }
  }
}
